/* ══════════════════════════════════════════════════════════════════
   Ein abgewiesener Schreibversuch wird gesagt, nicht verschluckt.

   P6-01 (letzte Prüfrunde, 05.10.2026): Die Prüferin stellte am Auftrag das
   Zahlungsziel um — die API wies mit 403 `recht.nur_lesen` ab, und die
   Auswahl sprang still zurück. Viele Masken zeigen den Fehler einer Änderung
   gar nicht (eine Auswahl, ein Haken), und wer nur lesen darf, kann jeden
   Knopf finden, den eine Maske noch nicht ausblendet.

   Darum an **einer** Stelle: Jede Mutation, die mit `recht.nur_lesen` (der
   Prüfer) oder `mandant.nur_lesen` (Betrieb auf Lesen, 423) scheitert,
   meldet sich hier (`main.tsx`, `MutationCache`), und die Rückmeldung
   (`schale/Ruf.tsx`) sagt den Satz. Die Knöpfe selbst blendet
   `useDarfSchreiben` aus (`schale/Sitzung.tsx`).
   ══════════════════════════════════════════════════════════════════ */

export type NurLesenArt = "pruefer" | "mandant";

/** Welcher Nur-Lese-Riegel hat abgewiesen — oder keiner. Rein. */
export function nurLesenAbgewiesen(fehler: unknown): NurLesenArt | null {
  if (typeof fehler !== "object" || fehler === null) return null;
  const schluessel = (fehler as { schluessel?: unknown }).schluessel;
  if (schluessel === "recht.nur_lesen") return "pruefer";
  if (schluessel === "mandant.nur_lesen") return "mandant";
  return null;
}

const hoerer = new Set<(art: NurLesenArt) => void>();

/** Aus dem `MutationCache`: ein Schreibversuch ist am Riegel gescheitert. */
export function nurLesenMelden(fehler: unknown): void {
  const art = nurLesenAbgewiesen(fehler);
  if (art) for (const h of hoerer) h(art);
}

/** Wer es sagen will — gibt das Abmelden zurück. */
export function aufNurLesen(h: (art: NurLesenArt) => void): () => void {
  hoerer.add(h);
  return () => { hoerer.delete(h); };
}
